package com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils

import androidx.compose.ui.graphics.Color
import com.trevorwiebe.timesheet.theme.successGreenText
import com.trevorwiebe.timesheet.theme.warningYellowText

/** UI-side color mapping for [TimeSheetStatus]; the enum itself lives in the shared module. */
val TimeSheetStatus.color: Color
    get() = when (this) {
        TimeSheetStatus.CURRENT_PERIOD -> Color.Black
        TimeSheetStatus.CONFIRM_HOURS_NOW -> warningYellowText
        TimeSheetStatus.CONFIRMED -> successGreenText
        TimeSheetStatus.PERIOD_CLOSED -> Color.Gray
    }
